import React from "react";
import { useHistory } from "react-router";
import { IoPersonOutline } from "react-icons/io5";
import { ReactComponent as LogoCasa } from "../../assets/images/logocdsmais.svg";
import { ReactComponent as SimboloCasa } from "../../assets/images/simbolo-cds.svg";
import useWindowWidthCalculate from "../../hooks/useWindowWidthCalculate";
import DesktopMenu from "../Menus/DesktopMenu";
import MobileMenu from "../Menus/MobileMenu";
import GoBackButton from "../GoBackButton";
import * as S from "./styles";

const HeaderExplore = ({ pageName, type = "full" }) => {
  const { isDesktop } = useWindowWidthCalculate();

  let history = useHistory();

  const handleClickProfile = () => {
    history.push("/minha-conta");
  };

  const handleClickPlans = () => {
    history.push("/signup");
  };

  const handleClickLogo = () => {
    history.push("/explore");
  };

  const variant = {
    full: (
      <>
        <S.Wrapper variant={"full"}>
          <div className="logo">
            <LogoCasa
              alt="Casa do Saber +"
              onClick={handleClickLogo}
              id={"btn-header-logo"}
              name={"btn-header-logo"}
            />
          </div>
          <S.Icons>
            <S.Text
              onClick={handleClickPlans}
              id={"btn-header-assine"}
              name={"btn-header-assine"}
            >
              Assine
            </S.Text>
            <IoPersonOutline
              id={"btn-header-profile"}
              name={"btn-header-profile"}
              onClick={handleClickProfile}
            />
          </S.Icons>
        </S.Wrapper>

        <MobileMenu />
      </>
    ),
    clean: (
      <S.Wrapper variant={"clean"}>
        <GoBackButton pageName={pageName} />
        <div
          className="logo"
          onClick={handleClickLogo}
          id={"btn-header-logo"}
          name={"btn-header-logo"}
        >
          <SimboloCasa alt="Símbolo Casa do Saber" />
        </div>
        <S.Icons>
          <S.Text
            onClick={handleClickPlans}
            id={"btn-header-assine"}
            name={"btn-header-assine"}
          >
            Assine
          </S.Text>
          <IoPersonOutline
            id={"btn-header-profile"}
            name={"btn-header-profile"}
            onClick={handleClickProfile}
          />
        </S.Icons>
      </S.Wrapper>
    ),
    transparent: (
      <S.Wrapper variant={"transparent"}>
        <GoBackButton />
        <S.Icons>
          <S.Text
            onClick={handleClickPlans}
            id={"btn-header-assine"}
            name={"btn-header-assine"}
          >
            Assine
          </S.Text>
          <IoPersonOutline
            id={"btn-header-profile"}
            name={"btn-header-profile"}
            onClick={handleClickProfile}
          />
        </S.Icons>
      </S.Wrapper>
    ),
    minimal: (
      <S.Wrapper variant={"minimal"}>
        <GoBackButton pageName={pageName} />
      </S.Wrapper>
    ),
  };

  const renderMobile = () => {
    return <>{variant[type] || variant["full"]}</>;
  };

  const renderDesktop = () => {
    return (
      <>
        <S.Wrapper>
          <div className="logo">
            <LogoCasa
              alt="Casa do Saber +"
              onClick={handleClickLogo}
              id={"btn-header-logo"}
              name={"btn-header-logo"}
            />
          </div>
          <S.Icons>
            <S.Text
              onClick={handleClickPlans}
              id={"btn-header-assine"}
              name={"btn-header-assine"}
            >
              Assine
            </S.Text>
            <IoPersonOutline
              id={"btn-header-profile"}
              name={"btn-header-profile"}
              onClick={handleClickProfile}
            />
          </S.Icons>
        </S.Wrapper>

        <DesktopMenu />

        {pageName && <GoBackButton pageName={pageName} />}
      </>
    );
  };

  return <>{isDesktop ? renderDesktop() : renderMobile()}</>;
};

export default HeaderExplore;
